import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  routeStepsCount: 1,
  ProfileMobileSidebar: false,
};

export const CommonSlice = createSlice({
  name: "UserSlice",
  initialState,
  reducers: {
    SetRouteStepsCount: (state) => {
      state.routeStepsCount += 1;
    },
    SetProfileMobileSidebar: (state, action) => {
      state.ProfileMobileSidebar = action.payload;
    },
  },
});

export const { SetRouteStepsCount, SetProfileMobileSidebar } =
  CommonSlice.actions;
export default CommonSlice.reducer;
